import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import Card from '../ui/Card'
import MediaImage from '../ui/MediaImage'
import { fadeInUp, staggerContainer, viewportOnce } from '../../utils/animations'
import { useLanguage } from '../../context/LanguageContext'
import { useProgramsData } from '../../hooks/useProgramsData'
import { countryFlag } from '../../utils/countryFlag'

export default function ProgramsGrid() {
  const { t } = useTranslation()
  const { isRTL } = useLanguage()
  const { programs } = useProgramsData()

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={staggerContainer}
      className="grid gap-8 md:grid-cols-3"
    >
      {programs.map(({ key, to, image, gradient, title, description, countryCode }) => (
        <motion.div key={key} variants={fadeInUp}>
          <Card padding={false} className="group overflow-hidden">
            <div className="relative h-52 overflow-hidden">
              <MediaImage
                src={image}
                alt={title}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div
                className={`absolute inset-0 bg-gradient-to-t ${gradient} opacity-60 mix-blend-multiply`}
              />
              {countryCode && (
                <span
                  className="absolute top-3 end-3 flex h-9 w-9 items-center justify-center rounded-full bg-white/95 text-xl shadow-md ring-1 ring-black/10 backdrop-blur-sm"
                  aria-hidden
                >
                  {countryFlag(countryCode)}
                </span>
              )}
              <div className="absolute bottom-4 start-4 end-4">
                <h3 className="text-xl font-bold text-white">{title}</h3>
              </div>
            </div>
            <div className="p-6">
              <p className="mb-4 text-sm leading-relaxed text-text/70">{description}</p>
              <Link
                to={to}
                className="inline-flex items-center gap-2 text-sm font-semibold text-primary transition-colors hover:text-accent"
              >
                {t('buttons.learnMoreAbout', { title })}
                <ArrowRight
                  className={`h-4 w-4 transition-transform group-hover:translate-x-1 ${isRTL ? 'rotate-180 group-hover:-translate-x-1' : ''}`}
                />
              </Link>
            </div>
          </Card>
        </motion.div>
      ))}
    </motion.div>
  )
}
